import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Typography, Stack, Grid, List, ListItem, ListItemText } from '@mui/material';
import logo from '../assets/logo/marmin_logo.png';

function RequestEInvoiceErrorPage() {
  const navigate = useNavigate();
  const { businessId } = useParams();

  const handleBackHome = () => {
    navigate(`/request-e-invoice/${businessId}`);
  };

  return (
    <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}>
      <Grid size={{ xs: 12, sm: 8, md: 6 }}>
        <Grid sx={{ p: 4, textAlign: 'center' }}>
          <Box sx={{ mb: 4 }}>
            <img src={logo} alt="Marmin Logo" style={{ maxWidth: '250px' }} />
          </Box>
          <Typography variant="h5" gutterBottom fontWeight="bold">
            Invoice request is blocked
          </Typography>
          <Typography variant="body1" sx={{ mt: 2 }}>
            Reason might be:
          </Typography>
          <Stack spacing={1} sx={{ textAlign: 'left', mb: 4 }}>
            <List sx={{ listStyleType: 'disc', pl: 2 }}>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText primary="Deadline to request e-invoice has passed" />
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText primary="Invoice already submitted to LHDN by the merchant" />
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText primary="Document is already an e-invoice" />
              </ListItem>
              <ListItem sx={{ display: 'list-item' }}>
                <ListItemText primary="Invoice/receipt number not found" />
              </ListItem>
            </List>
          </Stack>
          <Button variant="contained" color="primary" onClick={handleBackHome}>
            Back Home
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default RequestEInvoiceErrorPage;
